export default {"src":"/_next/static/media/sponser4.9e20a0dc.svg","height":32,"width":133,"blurWidth":0,"blurHeight":0};